/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The user role.
 * @export
 */
export const WebApiModelsEnumerationTypesRole = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;
export type WebApiModelsEnumerationTypesRole = typeof WebApiModelsEnumerationTypesRole[keyof typeof WebApiModelsEnumerationTypesRole];


export function WebApiModelsEnumerationTypesRoleFromJSON(json: any): WebApiModelsEnumerationTypesRole {
    return WebApiModelsEnumerationTypesRoleFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesRole {
    return json as WebApiModelsEnumerationTypesRole;
}

export function WebApiModelsEnumerationTypesRoleToJSON(value?: WebApiModelsEnumerationTypesRole | null): any {
    return value as any;
}

